import styled from 'styled-components';

export const GridTableCell = styled.div<{
  textAlign?: 'center' | 'left' | 'right';
}>`
  padding: 0.375rem 0.5rem;
  border-bottom: 0.0625rem dotted #dedede;
  text-align: ${({ textAlign }) => textAlign};
`;

export const GridTableHeaderCell = styled(GridTableCell)<{
  textAlign: 'center' | 'left' | 'right';
  isSortable: boolean;
  theme: string;
}>`
  border-bottom: ${({ theme }) =>
    theme === 'lightYellow'
      ? '0.125rem solid #9d7806'
      : '0.125rem solid #dedede'};
  font-weight: 500;
  text-align: ${({ textAlign }) => textAlign};
  cursor: ${({ isSortable }) => (isSortable ? 'pointer' : 'default')};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};
`;
